<div class="page-body">
  <div class="row">
    <div class="col-sm-12">
      <app-card [title]="'global.archive'|translate">
        <app-grid [grid]="grid" ></app-grid>
        <button class="btn btn-primary ripple light pull-right my-3" routerLink="/back-office/parts/overview" type="button">{{'admin.part.view_part'|translate}}</button>
      </app-card>
    </div>
  </div>
</div>

<app-modal-basic #reAddModel>
  <div class="app-modal-header">
    <h4 class="modal-title">{{ 'global.soft_readd_title' | translate:{entity: 'part'} }}</h4>
    <button type="button" class="close basic-close" (click)="reAddModel.hide()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="app-modal-body">
    <p>{{ 'global.soft_readd_body' | translate}} : <span [innerHTML]="partName"></span> ?</p>
  </div>
  <div class="app-modal-footer">
    <button type="button" class="btn btn-simple ripple me-4" (click)="reAddModel.hide()">{{'global.cancel'|translate}}</button>
    <button type="button" class="btn btn-primary ripple light" (click)="reAdd()">{{'global.actions.readd'|translate}}</button>
  </div>
</app-modal-basic>

